module.exports = __webpack_public_path__ + "img/sumInfoExportAct.8a6a6e0d.png";